var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
var _templateObject;
import "core-js/modules/es.string.trim-end.js";
import { useStaticQuery } from "gatsby";
import { useI18next, useTranslation } from "gatsby-plugin-react-i18next";
import marked from "marked";
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import CMSRichtext from "../../../blue-library/elements/cmsRichtext";
import { useMinScreen } from "../../../blue-library/utils/useMinScreen";
import { getGaProductCategory, getGaProductName } from "../../../qnb/gtmConverter";
import { GtmManagerContext, pushDataLayer } from "../../../shared/context/gtm-manager";
var MarkdownContainer = styled.div.withConfig({ displayName: "accordion__MarkdownContainer", componentId: "sc-akx1jg-0" })(["& *{", "}& table{", " width:calc(100% - 2rem);}& thead{", "}& thead > tr{", "}& thead th{", " border-width:1px;border-color:rgba(215,232,255,var(--tw-border-opacity));word-break:break-word;}& tbody{", ";background-image:radial-gradient( 100% 675.29% at 0% -4.34%,rgba(255,255,255,0.9) 0%,rgba(255,255,255,0.8) 100% );font-size:18px;letter-spacing:0.01rem;}& tr{", "}& td:nth-child{&(1){min-width:120px;}}& td{", " border-width:1px;border-color:rgba(215,232,255,var(--tw-border-opacity));}"], { "paddingTop": "1rem", "paddingBottom": "1rem", "overflow": "auto" }, { "tableLayout": "auto", "width": "640px", "borderRadius": "1rem", "overflow": "hidden", "minWidth": "600px", "@media (min-width: 1024px)": { "width": "1024px" } }, { "fontSize": "18px", "letterSpacing": "0.01rem", "--tw-text-opacity": "1", "color": "rgba(255, 255, 255, var(--tw-text-opacity))" }, { "fontSize": "18px", "letterSpacing": "0.16px", "--tw-text-opacity": "1", "color": "rgba(255, 255, 255, var(--tw-text-opacity))" }, { "padding": "1rem", "--tw-bg-opacity": "1", "backgroundColor": "rgba(99, 167, 255, var(--tw-bg-opacity))" }, { "fontSize": "18px", "letterSpacing": "0.01rem" }, { "fontSize": "18px", "letterSpacing": "0.01rem", "padding": "1rem", "verticalAlign": "top" }, { "--tw-text-opacity": "1", "color": "rgba(48, 52, 57, var(--tw-text-opacity))", "padding": "1rem", "verticalAlign": "top" });
var Accordion = function Accordion(_ref) {
    var title = _ref.title, content = _ref.content, content2 = _ref.content2, color = _ref.color, parentTitle = _ref.parentTitle, partnerCodeMapping = _ref.partnerCodeMapping, discountCodeMapping = _ref.discountCodeMapping, gtmLable = _ref.gtmLable, gtmLocation = _ref.gtmLocation, contentfulId = _ref.contentfulId, openIn = _ref.openIn, height = _ref.height;
    var gtm = React.useContext(GtmManagerContext);
    var _useState = useState(false), show = _useState[0], setShow = _useState[1];
    var _useState2 = useState(false), display = _useState2[0], setDisplay = _useState2[1]; // const [debug, setDebug] = useState("");
    var _useI18next = useI18next(), language = _useI18next.language;
    var _useTranslation = useTranslation(), t = _useTranslation.t;
    var _useSelector = useSelector(function (state) { return state.ui; }), dialogOpen = _useSelector.dialogOpen;
    var titleInEnglish;
    var productCode;
    var isWeMedi;
    var GET_ENGLISH_TITLE = "3353393952";
    var data = useStaticQuery(GET_ENGLISH_TITLE);
    data.allContentfulAccordion.edges.map(function (id) { if (id.node.contentful_id === contentfulId) {
        return titleInEnglish = id.node.title, id.node.accordionscomponent !== null && id.node.accordionscomponent !== undefined && id.node.accordionscomponent[0].page !== null && id.node.accordionscomponent[0].page !== undefined ? productCode = id.node.accordionscomponent[0].page[0].productCode : null;
    } });
    var heightrem = height ? Number(height) / 16 : undefined;
    var displayMappingHandler = function displayMappingHandler(partnerCodeMapping, discountCodeMapping) {
        if (partnerCodeMapping == null && discountCodeMapping == null) {
            return true;
        }
        var currentURLSearch = window.location.search;
        var params = new URLSearchParams(currentURLSearch);
        var paramDiscountList = __spreadArray([], __read(params.keys()), false).filter(function (key) { return key.startsWith("discountCode"); });
        var isPartnerCodeHere = params.get("partnerCode") !== null ? true : false;
        var isDiscountCodeHere = paramDiscountList.length > 0 ? true : false;
        var getPartnerCodeMatchResult = function getPartnerCodeMatchResult() { var result = "cmsNotMatch"; if (partnerCodeMapping == null) {
            return "cmsNull";
        } partnerCodeMapping.map(function (value) { if (value == params.get("partnerCode")) {
            result = "cmsMatch";
        } if (value == "DEFAULT") {
            result = "cmsDefault";
        } }); return result; };
        var getDiscountCodeMatchResult = function getDiscountCodeMatchResult() { var result = "cmsNotMatch"; if (discountCodeMapping == null) {
            return "cmsNull";
        } discountCodeMapping.forEach(function (cmsValue) { paramDiscountList.forEach(function (urlKey) { if (cmsValue == params.get(urlKey)) {
            result = "cmsMatch";
        } }); if (cmsValue == "DEFAULT") {
            result = "cmsDefault";
        } }); return result; }; // setDebug(
        //   `isPartnerCodeHere: ${
        //     isPartnerCodeHere ? "true" : "false"
        //   }, isDiscountCodeHere: ${
        //     isDiscountCodeHere ? "true" : "false"
        //   } , getPartnerCodeMatchResult: ${getPartnerCodeMatchResult()}  , getDiscountCodeMatchResult: ${getDiscountCodeMatchResult()}  `
        // );
        // if accordion
        if (isPartnerCodeHere && getPartnerCodeMatchResult() == "cmsMatch") {
            if (isDiscountCodeHere && getDiscountCodeMatchResult() == "cmsMatch") {
                return true;
            }
            if (!isDiscountCodeHere && getDiscountCodeMatchResult() == "cmsNull") {
                return true;
            }
            return false;
        }
        if (!isPartnerCodeHere && getPartnerCodeMatchResult() == "cmsNull") {
            if (isDiscountCodeHere && getDiscountCodeMatchResult() == "cmsMatch") {
                return true;
            }
            if (!isDiscountCodeHere && getDiscountCodeMatchResult() == "cmsNull") {
                return true;
            }
        }
        if (!isPartnerCodeHere && getPartnerCodeMatchResult() == "cmsDefault" && !isDiscountCodeHere && getDiscountCodeMatchResult() == "cmsDefault") {
            return true;
        }
    };
    useEffect(function () {
        setDisplay(displayMappingHandler(partnerCodeMapping, discountCodeMapping)); // setHere(displayMappingHandler(partnerCodeMapping, discountCodeMapping));
    }, []);
    var _useMinScreen = useMinScreen(), min = _useMinScreen.min;
    var isLg = min(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["lg"])));
    return /*#__PURE__*/ React.createElement("div", { className: (display ? "" : "hidden ") + " w-full border-b  nested-ol nested-ul border-" + (color ? color : "black-60") + " " + (isLg ? "w-850px m-auto" : ""), style: heightrem ? { paddingTop: heightrem + "rem", paddingBottom: "1rem" } : { paddingTop: '1rem', paddingBottom: '1rem' } }, /*#__PURE__*/ React.createElement("div", { className: "px-4 accordion-no-BulletPointWrapper" }, /*#__PURE__*/ React.createElement("div", { className: "flex cursor-pointer", onClick: function onClick() {
            setShow(!show);
            var path = window.location.pathname;
            var parts = path.split("/");
            var loc = parts[parts.length - 2];
            var category = parts[parts.length - 1]; // if (category.startsWith("wemedi-group-medical-protector")) {
            //   isWeMedi = true;
            // }
            if (loc !== "category" && !isWeMedi) {
                pushDataLayer({ event: "trackEventNoEcommerce",
                    "eventDetails.category": "accordion",
                    "eventDetails.action": !show ? "show" : "hide",
                    "eventDetails.label": titleInEnglish,
                    typeOfPolicy: category === "endowment-insurance-promotion#faqs" || category === "endowment-insurance-promotion" ? "WeSave E1" : category === "savings-insurance-promo-code#faqs" || category === "savings-insurance-promo-code" ? "WeSave S3" : category === "wecare-flexible-term-life-protection-plan-1" ? "WeCare Flexible Term Life 1" : category === "wecare-term-life-protection-plan-3" ? "WeCare Term Life 3" : getGaProductName(productCode),
                    policyCategory: category === "endowment-insurance-promotion#faqs" || category === "endowment-insurance-promotion" ? "WeSave" : category === "savings-insurance-promo-code#faqs" || category === "savings-insurance-promo-code" ? "WeSave" : category === "kids-protection" ? "Others" : getGaProductCategory(productCode),
                    location: "product" //required
                });
            }
            else {
                var _titleInEnglish;
                var _path = window.location.pathname;
                var _parts = _path.split("/");
                var _category = _parts.pop();
                pushDataLayer({ event: "trackEventNoEcommerce",
                    "eventDetails.category": "accordion",
                    "eventDetails.action": !show ? "show" : "hide",
                    "eventDetails.label": (_titleInEnglish = titleInEnglish) === null || _titleInEnglish === void 0 ? void 0 : _titleInEnglish.trimEnd(),
                    policyCategory: _category === "easy-protector" ? "micro insurance" : _category === "medical-cover" || _category === "wemedi-group-medical-protector" ? "WeMedi" : _category === "kids-protection" ? "Others" : _category === "term-life-protection" || _category === "personal-accident-protection" || _category === "critical-illness-insurance" ? "WeCare" : isWeMedi ? "WeMedi" : _category === "savings-plans" ? "WeSave" : undefined,
                    location: "product category" //required
                });
            }
            {
                gtmLable && gtmLocation && gtm.push({ event: "trackEventNoEcommerce",
                    "eventDetails.category": !dialogOpen ? "accordion" : "accordion_dialog",
                    "eventDetails.action": !show ? "show" : "hide",
                    "eventDetails.label": "Terms and Conditions",
                    location: gtmLocation //required
                });
            }
        } }, /*#__PURE__*/ React.createElement("div", { className: "text-" + (color ? color : "corporate-1") + " flex items-center justify-between w-full" }, title === t("quickQuoteTNC") ? /*#__PURE__*/ React.createElement("div", { className: "h5" }, title) : /*#__PURE__*/ React.createElement("h3", { className: "h5" }, title), /*#__PURE__*/ React.createElement("i", { className: (show ? "i-angle-up" : "i-angle-down") + " text-24px" }))), content && /*#__PURE__*/ React.createElement("div", { className: "pt-4 text-b-2 " + (show ? "" : "hidden") }, /*#__PURE__*/ React.createElement(CMSRichtext, { text: content, pdfUrl: true, lang: language, cmstype: color, openIn: openIn })), (content2 === null || content2 === void 0 ? void 0 : content2.content2) && /*#__PURE__*/ React.createElement(MarkdownContainer, null, /*#__PURE__*/ React.createElement("div", { className: "pt-4 text-b-2 " + (show ? "" : "hidden"), dangerouslySetInnerHTML: { __html: marked(content2.content2) } }))));
};
export default Accordion;
